module.exports = __webpack_public_path__ + "static/media/MottagarePeop.1dc72896.svg";